<script setup>
import { defineProps, computed, reactive, ref, watch } from 'vue';
import VueApexCharts from "vue3-apexcharts";

const chartLabelColor = '#fff';
const chartBarColor = '#4CAF50';

const props = defineProps({
    data: {
        type: Array,
        required: true,
    },
    chartTitle: {
        type: String,
        default: null,
    },
    xAxisTitle: {
        type: String,
        default: null,
    },
    yAxisTitle: {
        type: String,
        default: null,
    },
});

let chartOptions = ref({
    chart: {
        width: "100%",
        height: "auto",
        type: "bar",
        foreColor: '#898989',
        zoom: {
            enabled: false
        },
        toolbar: {
            show: false
        },
    },
    colors: [chartBarColor],
    stroke: {
        width: 0,
    },
    plotOptions: {
        bar: {
            dataLabels: {
                position: 'top'
            }
        }
    },
    dataLabels: {
        enabled: true,
        offsetY: -20
    },
    title: {
        text: props.chartTitle || '',
        align: 'center',
        style: {
            fontSize: '14px',
            fontWeight: 'bold',
            color: chartLabelColor
        },
    },
    grid: {
        enabled: false,
        yaxis: {
            lines: {
                show: false
            }
        },
        xaxis: {
            lines: {
                show: false
            }
        }
    },
    xaxis: {
        axisBorder: {
            color: chartLabelColor,
        },
        title: {
            text: props.xAxisTitle || '',
            style: {
                color: chartLabelColor
            }
        }
    },
    yaxis: {
        min: 0,
        axisBorder: {
            color: chartLabelColor,
        },
        title: {
            text: props.yAxisTitle || '',
            style: {
                color: chartLabelColor,
            },
        },
        tooltip: {
            enabled: true,
        },
    },
    fill: {
        opacity: 1,
    },
    tooltip: {
        enabled: false,
    }
});

const dataParsed = computed(() => {
    return props.data.map((item) => {
        return {
            x: item['Day_of_week'],
            y: item['Total_Reps']
        }
    });
});

const series = reactive([
    {
        color: chartBarColor,
        zIndex: 1,
        data: dataParsed || []
    }
])


watch(() => props.data, (newValue) => {
    series[0].data = dataParsed;
});
</script>

<template>
    <div class="daysOfWeekChart">
        <VueApexCharts type="bar" :options="chartOptions" :series="series" height="400" />
    </div>
</template>